import { ReactNode, useMemo } from "react";
import CheckIcon from "assets/icons/CheckIcon";
import Loader from "../../../Loader";
import { TileTypes } from "..";

import styles from "./style.module.scss";

const Tile = ({
  title,
  progress,
  tileIndex,
}: TileTypes & { tileIndex: number }) => {
  const progressText =
    progress < 100
      ? title === "Initializing"
        ? "Preparing resources…"
        : `${progress}%`
      : "Completed";

  const icon = useMemo((): ReactNode => {
    if (progress < 100)
      return (
        <div className={styles.loader}>
          <Loader />
        </div>
      );

    return (
      <div className={styles.completedIcon}>
        <CheckIcon variant="flat" />
      </div>
    );
  }, [progress]);

  return (
    <div
      className={styles.tile}
      style={{ animationDelay: `${tileIndex * 0.4}s` }}
    >
      <div className={styles.tileIcon}>{icon}</div>
      <div className={styles.tileInfo}>
        <div className={styles.tileTitle}>{title}</div>
        <div className={styles.tileProgress}>{progressText}</div>
      </div>
    </div>
  );
};

export default Tile;
